import {
	SET_SERVICES,
	SET_SERVICE,
	CLEAR_SERVICES,
	CLEAR_SERVICE,
	ADD_SERVICE,
	UPDATE_SERVICE,
	REMOVE_SERVICE,
} from './actionTypes';

export const service = (state = {}, action) => {
	switch (action.type) {
		case SET_SERVICE:
			return action.payload;
		case UPDATE_SERVICE:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_SERVICE:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_SERVICES:
			return action.payload;
		case ADD_SERVICE:
			return [...state, action.payload];
		case UPDATE_SERVICE:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_SERVICE:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_SERVICES:
			return [];
		default:
			return state;
	}
};
